import { useState } from "react";
import { COMMON_FIELD_TYPES } from "../constants/fieldTypes";
import { validateField } from "../utils/validationUtils";

const useForm = (initialValues = {}, requiredFields = {}, inputTypes = {}) => {
  const [formData, setFormData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouchedState] = useState({});

  const handleInputChange = (name, value) => {
    let updatedValue = value;

    // console.log("Before Update:", name, value);

    // Handle dropdown selections
    if (
      inputTypes[name]?.type === COMMON_FIELD_TYPES.DROPDOWN &&
      typeof value === "object"
    ) {
      updatedValue = value?.[inputTypes[name].displayKey] || "";
    }

    setFormData((prev) => {
      const newFormData = { ...prev, [name]: updatedValue };

      // Validate using updated formData
      const error = validateField(
        name,
        inputTypes[name],
        updatedValue?.trim(),
        newFormData,
        requiredFields
      );

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));

      return newFormData;
    });
  };

  const handleBlur = (name, value) => {
    // console.log("On Blur:", name, value);

    let sanitizedValue = value?.trim() || value;

    // Sanitizing the date input
    if (inputTypes[name] === COMMON_FIELD_TYPES.DATE_PICKER) {
      // console.log(sanitizedValue);
      sanitizedValue = sanitizedValue ? new Date(sanitizedValue)?.toISOString()?.split("T")[0] : "";
      // console.log(sanitizedValue);
      
    }

    // Sanitizing the time input
    if (inputTypes[name] === COMMON_FIELD_TYPES.TIME_PICKER && sanitizedValue) {
      // Ensure the time is in the correct format: 'hh:mm AM/PM'
      const [hourMinute, period] = sanitizedValue.split(" ");

      if (hourMinute && period) {
        const [hour, minute] = hourMinute.split(":");
        const sanitizedHour = hour?.padStart(2, "0");
        const sanitizedMinute = minute?.padStart(2, "0");
        sanitizedValue = `${sanitizedHour}:${sanitizedMinute} ${period.toUpperCase()}`;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));

    setTouchedState((prev) => ({
      ...prev,
      [name]: true,
    }));

    // Validate the field on blur
    const error = validateField(
      name,
      inputTypes[name],
      sanitizedValue,
      formData,
      requiredFields
    );

    // console.log("error", error);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // Function to clear errors on focus
  const clearError = (name) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      
      newErrors[key] = validateField(
        key,
        inputTypes[key],
        typeof formData[key] === "string" ? formData[key]?.trim() : formData[key],
        formData,
        requiredFields
      );
    });

    // console.log(newErrors);
    
    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };

  return {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    clearError,
    validateForm,
    setTouched: setTouchedState,
    setErrors,
    setFormData,
  };
};

export default useForm;
